import { useState } from 'react';

// Popup filters narrow the records already scoped by the page filters.
export function useEmployeeDetailFilters(records, source) {
    const [country, setCountry] = useState('');
    const [hcType, setHcType] = useState('');
    const isEmployee = record => (record._source || source) === 'hc';
    const employees = records.filter(isEmployee);
    const options = field => [...new Set(employees.map(r => r[field]).filter(Boolean))].sort();
    const visible = source === 'hc' || employees.length > 0;
    return {
        records: records.filter(r => !isEmployee(r)
            || ((!country || r.country === country) && (!hcType || r.hc_type === hcType))),
        controls: visible ? <div className="esd-employee-filters">
            <label className="esd-filterbar-field">
                <span className="esd-filterbar-field-label">Country</span>
                <select className="esd-filter-select" value={country} onChange={e => setCountry(e.target.value)}>
                    <option value="">All Countries</option>
                    {options('country').map(value => <option key={value} value={value}>{value}</option>)}
                </select>
            </label>
            <label className="esd-filterbar-field">
                <span className="esd-filterbar-field-label">HC Type</span>
                <select className="esd-filter-select" value={hcType} onChange={e => setHcType(e.target.value)}>
                    <option value="">All Types</option>
                    {options('hc_type').map(value => <option key={value} value={value}>{value}</option>)}
                </select>
            </label>
            {source === 'total' && <small>Filters apply to employees.</small>}
        </div> : null,
    };
}
